var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-radio"},_vm._l((_vm.options),function(option,index){return _c('button',{key:index,staticClass:"r-radio--button",class:{ 'r-radio--button__current': _vm.current === index },on:{"click":function($event){return _vm.toggleCurrent(index)}}},[_vm._v(" "+_vm._s(option.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }